import { ChangeSocial } from './ChangeSocial';

export class ChangeLinkedIn extends ChangeSocial {
  type: string = 'ChangeLinkedIn';
}
